import React, { FC, MouseEventHandler, useState } from 'react';
import { DrawerFooter, Dropdown, RegularButton } from 'fronton-react';
import { Drawer, DrawerContent, DrawerHeader } from 'fronton-react/drawer';
import { analyticsUtils } from 'utils';
import { VariantsAxisModel, Product } from 'features/variants';
import { useTranslation } from 'react-i18next';
import { drawerHeaderPadding, drawerScroll, multiDropdown, variantDrawer } from './styles';
import { VariantsDrawerContent } from './components';
import { handleConfirm } from './utils/handle-confirm';

export const DATA_QA_VARIANT_MULTISELECT = 'pdp-variant-multiselect';

type Props = {
  activePoint?: Product;
  variantsModel?: VariantsAxisModel[];
  isProductSet: boolean;
};

export const MultiAxisDropdown: FC<Props> = ({ activePoint, variantsModel, isProductSet }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState<boolean>(false);
  const [pendingVariantUrl, setPendingVariantUrl] = useState<string | null>(null);
  const dropdownString = activePoint?.axesValues.map((axisValue) => axisValue.axis).join(' / ') || '';

  const sendDropdownGA = () => {
    const elementName = variantsModel?.map((axis) => axis.axisMeta.name).join(' / ') || '';
    const elementText = dropdownString;
    analyticsUtils.sendEvent('GA:clickButton', {
      elementType: 'button',
      elementBlock: isProductSet ? 'komplektyDetail / variants' : 'productDetail / variants',
      elementName,
      elementText,
    });
  };

  const dropdownCallback: MouseEventHandler<HTMLDivElement> = () => {
    /**
     * here will be modal open callback
     */
    sendDropdownGA();
    setShowModal(true);
    setPendingVariantUrl(null);
  };

  const closeDrawer = () => {
    /**
     * here will be modal open callback
     */
    setShowModal(false);
  };

  const onConfirm = () => {
    handleConfirm(pendingVariantUrl, closeDrawer);
  };

  return (
    <>
      <div data-qa={DATA_QA_VARIANT_MULTISELECT} onClick={dropdownCallback}>
        <Dropdown
          label={t('variants.multi-label')}
          className={multiDropdown}
          disabled
          value={dropdownString}
        />
      </div>

      <Drawer className={variantDrawer} onClose={closeDrawer} show={showModal}>
        <DrawerHeader title="" sticky className={drawerHeaderPadding} onClickBack={closeDrawer} />
        <DrawerContent className={drawerScroll}>
          <VariantsDrawerContent
            key={showModal ? 'open' : 'closed'}
            onVariantSelect={setPendingVariantUrl}
          />
        </DrawerContent>
        <DrawerFooter sticky>
          <RegularButton onClick={onConfirm} wide>
            {t('variants.select')}
          </RegularButton>
        </DrawerFooter>
      </Drawer>
    </>
  );
};
